import { useState } from "preact/hooks";
import { Redirect } from "wouter-preact";
import { signInWithProvider } from "../api/auth";
import { Wordmark } from "../components/Wordmark";
import { Disclaimer } from "../components/Disclaimer";
import { authError, dismissAuthError, session } from "../state";

/**
 * Sign-in (`/login`).
 *
 * A failed OAuth round-trip never reaches this component's URL: `captureAuthError`
 * lifts the callback's error params into `authError` before the router runs, so
 * they survive the `/` → `/login` redirect. A closed-beta rejection is handed to
 * `/beta-full`; anything else is shown inline and speaks for itself.
 */
export function Login() {
  const [status, setStatus] = useState<"idle" | "redirecting">("idle");
  const [error, setError] = useState("");

  if (session.value) return <Redirect to="/ask" />;
  if (authError.value?.betaFull) return <Redirect to="/beta-full" />;

  const message = error || authError.value?.message || "";

  async function signIn() {
    if (status === "redirecting") return;
    setStatus("redirecting");
    setError("");
    dismissAuthError();
    try {
      await signInWithProvider("google");
    } catch (err) {
      setStatus("idle");
      setError(
        err instanceof Error ? err.message : "Could not start sign-in.",
      );
    }
  }

  return (
    <div class="view">
      <div class="view__center login content">
        <div class="login__card">
          <div class="login__brand">
            <Wordmark />
            <h1 class="login__title">
              Ask the <em>judge</em>.
            </h1>
            <p class="login__subtitle">
              Sign in with Google to ask Flesh and Blood rules questions.
            </p>
          </div>

          <div class="login__form">
            <button
              type="button"
              class="btn btn--primary"
              onClick={signIn}
              disabled={status === "redirecting"}
            >
              {status === "redirecting"
                ? "Redirecting…"
                : "Continue with Google"}
            </button>
            {message && (
              <p class="login__hint" role="alert">
                {message}
              </p>
            )}
          </div>
        </div>
        <Disclaimer />
      </div>
    </div>
  );
}
